import { IFilter, IGenericObject, IMatchObject, IQueryParams } from '@types'

export const generateQuery = (queryParam: IQueryParams) => {
  const { params, additionalFilters, range } = queryParam
  const query: IMatchObject[] = []
  const fuzzy: IMatchObject[] = []
  const creatMatchObject = (keyValue: [string, IFilter | null]) => {
    const [key, filter] = keyValue
    if (!filter) return

    if (filter.method === 'fuzzy') {
      if (filter && filter.value !== '')
        fuzzy.push({
          field: key,
          value: filter.value as string,
          operator: 'and',
        })
    }
    if (filter.method === 'normal') {
      if (filter.value && filter.value !== '')
        query.push({
          field: key,
          value: filter.value as string,
          operator: 'and',
        })
    }
    if (filter.method === 'boolean') {
      if (filter.value && filter.value !== '')
        query.push({
          field: key,
          value: '0',
          operator: filter.value === 'true' ? 'and' : 'not',
        })
    }
  }

  //filters
  Object.entries(params).forEach(creatMatchObject)
  //additionalFilters
  if (additionalFilters) {
    Object.entries(additionalFilters).forEach(creatMatchObject)
  }
  //range filters
  const rangeQuery: IGenericObject<string | number | null>[] = []
  if (range) {
    range.forEach((r) => {
      if (r) {
        rangeQuery.push({
          field: r.field,
          gte: r.domain[0] + 0.1,
          lte: r.domain[1],
          operator: 'and',
        })
      }
    })
  }

  return { match: query, range: rangeQuery, fuzzy }
}
